import {useQuery} from '@tanstack/react-query';
import {useSelector} from 'react-redux';
import {
  FolderTreeItem,
  getAssignmentsData,
  getFoldersData,
  getProductionSetsData,
  getSavedSearchListData,
} from '../../api/endpoints/corpusApi';
import {RootState} from '../../redux/store';

export const useGetFoldersList = (securityGroupId = 0) => {
  return useQuery<FolderTreeItem[], Error>({
    queryKey: ['foldersList'],
    queryFn: async () => {
      return getFoldersData(securityGroupId);
    },
    retry: 2,
  });
};

export const useGetSavedSearchList = () => {
  return useQuery<FolderTreeItem[], Error>({
    queryKey: ['savedSearchList'],
    queryFn: async () => {
      return getSavedSearchListData();
    },
    retry: 2,
  });
};

export const useGetProductionSetList = (securityGroupId = 0) => {
  const isProduction =
    useSelector(
      (state: RootState) =>
        state.categorization.proviewProductionDetails?.isProduction
    ) ?? true;

  return useQuery<FolderTreeItem[], Error>({
    queryKey: ['productionSetsList', securityGroupId, isProduction],
    queryFn: async () => {
      return getProductionSetsData(securityGroupId, isProduction);
    },
    retry: 2,
  });
};

export const useGetAssignmentsList = () => {
  return useQuery<FolderTreeItem[], Error>({
    queryKey: ['assignmentsList'],
    queryFn: async () => {
      return getAssignmentsData();
    },
    retry: 2,
  });
};
